const GATE_CB_PATTERN = /^\d{13}-[a-fA-F0-9]{6,8}$/
const GATE_CB_SESSION_KEY = 'gate_cb'

export function randomHex(length = 6) {
  const size = Math.max(1, Number(length) || 6)
  const bytes = new Uint8Array(Math.ceil(size / 2))
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, size)
}

export function generateGateCb() {
  return `${Date.now()}-${randomHex(6)}`
}

export function isValidGateCb(value) {
  const cb = Array.isArray(value) ? value[0] : value
  return GATE_CB_PATTERN.test(String(cb || ''))
}

export function getOrCreateGateCb() {
  try {
    const saved = sessionStorage.getItem(GATE_CB_SESSION_KEY)
    if (isValidGateCb(saved)) return saved
  } catch (e) {
    // ignore
  }
  const next = generateGateCb()
  try {
    sessionStorage.setItem(GATE_CB_SESSION_KEY, next)
  } catch (e) {
    // ignore
  }
  return next
}

function rememberGateCb(value) {
  if (!isValidGateCb(value)) return
  try {
    sessionStorage.setItem(GATE_CB_SESSION_KEY, String(value))
  } catch (e) {
    // ignore
  }
}

export function ensureGateCbOnAddressBar(path) {
  if (path === '/kfchat.html' || String(path || '').startsWith('/kfchat')) return

  const url = new URL(window.location.href)
  const current = url.searchParams.get('cb')
  if (isValidGateCb(current)) {
    rememberGateCb(current)
    return
  }

  url.searchParams.set('cb', getOrCreateGateCb())
  window.history.replaceState(
    window.history.state,
    '',
    `${url.pathname}${url.search}${url.hash}`
  )
}

export function buildInviteRegisterUrl(webDomain, invitationCode) {
  const base = String(webDomain || window.location.origin).replace(/\/$/, '')
  const code = String(invitationCode || '').trim()
  if (!code) return ''
  const cb = getOrCreateGateCb()
  return `${base}/register?invitation_code=${encodeURIComponent(code)}&cb=${encodeURIComponent(cb)}`
}

export function getInvitationCodeFromLocation(routeQuery = {}) {
  const fromRoute = Array.isArray(routeQuery.invitation_code)
    ? routeQuery.invitation_code[0]
    : routeQuery.invitation_code
  if (fromRoute) return String(fromRoute).trim()

  try {
    return (new URLSearchParams(window.location.search).get('invitation_code') || '').trim()
  } catch (e) {
    return ''
  }
}

export function openMolinCustomerService(config) {
  const molinUrl = String(config?.molin_url || '').trim()
  if (!molinUrl) return false
  window.open(molinUrl, '_blank')
  return true
}

function normalizeExternalUrl(url) {
  const value = String(url || '').trim()
  if (!value) return ''
  if (value.startsWith('http://') || value.startsWith('https://')) return value
  return `http://${value}`
}

/** 优先 service_url，其次 molin；成功打开返回 true */
export function openCustomerService(config) {
  const serviceUrl = normalizeExternalUrl(config?.service_url)
  if (serviceUrl) {
    window.open(serviceUrl, '_blank')
    return true
  }
  return openMolinCustomerService(config)
}
